import { memo } from 'react';
import { useProgramPageRedirect } from '@pages/programs/program-page/helpres.ts';
import { Menu } from '@widgets/programs';
import {
  getProgramAuthorName,
  onProgramCardClick,
} from '@widgets/programs/program-card/helprers.ts';
import { ProgramCardProps } from '@widgets/programs/program-card/type.ts';
import * as st from '@features/articles/article-card/Small/styles.module.scss';
import { OpenIndicatorWithImage } from '@features/common/open-indicator';
import { SmallCard } from '@features/common/SmallCard/ArticleAndProgramCard';
import { SmallCardCost } from '@features/common/SmallCardCost/index.tsx';
import { SmallCardStatus } from '@features/common/SmallCardStatus/index.tsx';
import { useProgramAuthor } from '@features/programs';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';

// import { ChooseDay } from '@src/library/components/programs/VideoProgram/frames/Main/frames';

export const ProgramCard: React.FC<ProgramCardProps> = memo(
  ({ program, onClick, needDropDawnShowUp, activeTab }) => {
    const { opened, publication, moderation_status, cost, pk, favorite, is_paid, title, author } =
      program;
    const { doRedirectWithSavePageUrl } = useProgramPageRedirect();
    const { isAuthor } = useProgramAuthor(program.author.id);
    const { code } = useModuleByCodeParam();
    const onCardClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      onProgramCardClick({
        event,
        onClick,
        doRedirectWithSavePageUrl,
        url: `/programs/${code}/program/${program.pk}`,
      });
    };

    return (
      <SmallCard
        title={title}
        authorName={getProgramAuthorName(program)}
        onCardClick={onCardClick}
        openIndicatorNode={
          <OpenIndicatorWithImage
            activeTab={activeTab}
            isAuthor={isAuthor}
            isOpened={opened}
            isPublished={publication?.is_published || false}
            modStatus={moderation_status}
            onClick={onCardClick}
            imgSrc={program?.promo_image}
          />
        }
        smallCardStatusNode={
          <SmallCardStatus
            className={st.status}
            moderationStatus={moderation_status}
            isAuthor={isAuthor}
            isPublished={publication?.is_published}
            isPaid={is_paid}
            // cost={cost}
            isFavorite={favorite}
          />
        }
        smallCardCostNode={
          <SmallCardCost isAuthor={isAuthor} cost={cost} is_paid={program?.is_paid} />
        }
        menuNode={
          <Menu
            id={pk}
            needDropDawnShowUp={needDropDawnShowUp}
            authorId={author.id}
            coachId={author?.coach?.id}
            isFavorite={favorite}
            isPaid={is_paid}
            onMenuItemClick={onClick}
          />
        }
      />
    );
  }
);
